export function getdata() {
	let obj = {

			headData: [
					{
					title:"",
					prop: "Secondary",
					width: "50px",
					custom: true,

					},{
					title:"项目",
					prop: "title",
					width: "150px",

					custom: true,
				},
				{
					title:"栏次",
					prop: "grade",
					custom: true,
					width: "50px",
				},
				{
					title:'本期数',
					children:[
						{
							title:'货物及劳务',
							prop:'zzsxgm_0_x_1',
							width: "100px",
							custom: true,
						},{
							title:'服务、不动产和无形资产',
							prop:'zzsxgm_0_x_2',
							width: "100px",
							custom: true,
						},
					]
				},
				{
					title:'本年累计',
					children:[
						{
							title:'货物及劳务',
							prop:'zzsxgm_0_x_3',
							width: "100px",
							custom: true,
						},{
							title:'服务、不动产和无形资产',
							prop:'zzsxgm_0_x_4',
							width: "100px",
							custom: true,
						},
					]
				},

			],
			tableData: [{
					title:"（一）应征增值税不含税销售额（3%征收率）",
					Secondary:'一、计税依据',
					grade:'1',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_1_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_1_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_1_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_1_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},
				{
					title:"增值税专用发票不含税销售额 ",
					Secondary:'一、计税依据',
					grade:'2',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_2_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_2_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_2_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_2_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其他增值税发票不含税销售额",
					Secondary:'一、计税依据',
					grade:'3',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_3_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_3_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_3_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_3_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"（二）应征增值税不含税 销售额（5%征收率）",
					Secondary:'一、计税依据',
					grade:'4',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_4_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_4_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_4_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_4_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"增值税专用发票不含税销售额",
					Secondary:'一、计税依据',
					grade:'5',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_5_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_5_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_5_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_5_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其他增值税发票不含税销售额",
					Secondary:'一、计税依据',
					grade:'6',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_6_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_6_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_6_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_6_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"（三）销售使用过的固定资产不含税销售额",
					Secondary:'一、计税依据',
					grade:'7(7≥8)',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_7_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_7_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_7_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_7_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其中：其他增值税发票不含税销售额",
					Secondary:'一、计税依据',
					grade:'8',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_8_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_8_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_8_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_8_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"（四）免税销售额",
					Secondary:'一、计税依据',
					grade:'9=10+11+12',
					disabledzzsxgm_0_x_1:true,
					disabledzzsxgm_0_x_2:true,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_9_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_9_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_9_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_9_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其中：小微企业免税销售额",
					Secondary:'一、计税依据',
					grade:'10',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_10_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_10_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_10_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_10_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"未达起征点销售额",
					Secondary:'一、计税依据',
					grade:'11',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_11_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_11_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_11_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_11_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其他免税销售额",
					Secondary:'一、计税依据',
					grade:'12',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_12_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_12_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_12_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_12_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"（五）出口免税销售额",
					Secondary:'一、计税依据',
					grade:'13(13≥14)',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_13_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_13_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_13_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_13_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其中：其他增值税发票不含税销售额",
					Secondary:'一、计税依据',
					grade:'14',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_14_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_14_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_14_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_14_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"（六）核定销售额",
					Secondary:'一、计税依据',
					grade:'15',

					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_15_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					},
					zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_15_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					},
					zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_15_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					},
					zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_15_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					}
				},{
					title:"本期应纳税额",
					Secondary:'二、税款计算',
					grade:'16',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_16_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_16_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_16_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_16_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"核定应纳税额",
					Secondary:'二、税款计算',
					grade:'17',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_17_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_17_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_17_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_17_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"本期应纳税额减征额",
					Secondary:'二、税款计算',
					grade:'18',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_18_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_18_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_18_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_18_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"本期免税额",
					Secondary:'二、税款计算',
					grade:'19',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_19_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_19_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_19_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_19_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"其中：小微企业免税额",
					Secondary:'二、税款计算',
					grade:'20=15-16',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_20_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_20_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_20_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_20_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"未达起征点免税额",
					Secondary:'二、税款计算',
					grade:'21',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_21_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_21_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_21_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_21_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"应纳税额合计",
					Secondary:'二、税款计算',
					grade:'22',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_22_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_22_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_22_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_22_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"本期预缴税额",
					Secondary:'二、税款计算',
					grade:'23',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_23_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_23_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_23_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_23_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"本期应补（退）税额",
					Secondary:'二、税款计算',
					grade:'24',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_24_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_24_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_24_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_24_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"城市维护建设税本期应补（退）税额",
					Secondary:'三、附加税费',
					grade:'25',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_25_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_25_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_25_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_25_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"教育费附加本期应补（退）费额",
					Secondary:'三、附加税费',
					grade:'26',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_26_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_26_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_26_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_26_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				},{
					title:"地方教育附加本期应补（退）费额",
					Secondary:'三、附加税费',
					grade:'27',
					disabledzzsxgm_0_x_1:false,
					disabledzzsxgm_0_x_2:false,
					disabledzzsxgm_0_x_3:false,
					disabledzzsxgm_0_x_4:false,
					 zzsxgm_0_x_1: {
						 cellCode:" zzsxgm_0_27_1",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_2: {
						 cellCode:" zzsxgm_0_27_2",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_3: {
						 cellCode:" zzsxgm_0_27_3",
						 cellType:"1",
						 cellVal:"240040043.08"
					 },
					 zzsxgm_0_x_4: {
						 cellCode:" zzsxgm_0_27_4",
						 cellType:"1",
						 cellVal:"240040043.08"
					 }
				}
			]

	}
	return obj
}
